export default __webpack_public_path__ + "static/media/Sigmoid_Set_up_Male_.3a395425.png";